// extracted by mini-css-extract-plugin
export default {"appliedActionContainer":"PZC4BE","actionBody":"OReCX_"};